<template>
    <div class="page">
        <div class="top-banner"></div>
        <div class="title">
            <div class="page-line"></div>
            <div>生活消费大福袋</div>
            <div class="page-line"></div>
        </div>
        <div class="description">大牌优惠，价值168元超值礼包</div>
        <div class="content-title">生活出行 / 美食外卖 / 休闲娱乐 / 亲子教育</div>
        <div class="content">
            <div v-for="(item, index) in list" :key="index">
                <div class="bag">
                    <div class="bag-icon" :style="{ backgroundImage: `url(${item.icon})` }"></div>
                    <div class="bag-title">{{ item.title }}</div>
                </div>
            </div>
        </div>
        <div v-if="this.awardList.awardStatus === 2" class="updata">
            {{ '升至' + this.awardList.requiredScore + '活力值即可恢复继续领取资格' }}
        </div>
        <div v-if="showDescrip" class="check" @click="checkRights">
            {{ this.awardList.awardStatus === 0 ? '查看权益详情' : '点击查看已领取礼券' }}
        </div>

        <div class="butn" @click="butnClick">{{ butn_title }}</div>
        <div v-if="showDescrip" class="alert-div">
            {{ '升至' + this.awardList.requiredScore + '活力值可领' }}
        </div>

        <Dialog
            :show="showDialog"
            title="前往首页申请借款，成交后即可激活成长权益"
            lefttxt="再看看"
            righttxt="去首页"
            @giveupBtn="giveupBtn"
            @continueBtn="continueBtn"
        />
        <Dialog1
            :show="showUpdataDialog"
            title="做任务可以增加活力值哦！"
            lefttxt="再看看"
            righttxt="去做任务"
            @giveupBtn="giveupTask"
            @continueBtn="doSomeTask"
        />
        <Dialog2
            :show="showOverdueDialog"
            title="对不起，您当前存在逾期，请先完成还款。"
            lefttxt="再看看"
            righttxt="去还款"
            @giveupBtn="giveupToRepay"
            @continueBtn="doSomeRepay"
        />
    </div>
</template>

<script>
import homemixin from '@common/js/mixin';
import Dialog from '../../componets/birthday/homeDialog';
import Dialog1 from '../../componets/birthday/homeDialog';
import Dialog2 from '../../componets/birthday/homeDialog';
import appBridge from '@/common/util/appBridge';
export default {
    components: { Dialog, Dialog1, Dialog2 },
    mixins: [homemixin],
    data() {
        return {
            butn_title: '',
            isOldCustomer: false,
            showDescrip: false,
            showDialog: false,
            showUpdataDialog: false,
            showOverdueDialog: false,
            goluckBag: false,
            totalScore: 0,
            awardList: {},
            list: [
                { title: '饿了么', icon: require('@/assets/luckybag/elm@2x.png') },
                { title: '中石化', icon: require('@/assets/luckybag/zsh-icon@2x.png') },
                { title: '滴滴出行', icon: require('@/assets/luckybag/didi-icon@2x.png') },
                { title: 'Keep', icon: require('@/assets/luckybag/Keep@2x.png') },
                { title: '肯德基', icon: require('@/assets/luckybag/kdj-icon@2x.png') },
                { title: '麦当劳', icon: require('@/assets/luckybag/mddn-icon@2x.png') },
                { title: '哈根达斯', icon: require('@/assets/luckybag/hgds-icon@2x.png') },
                { title: '星巴克', icon: require('@/assets/luckybag/xbk-icon@2x.png') },
                { title: '网易云音乐', icon: require('@/assets/luckybag/wyyyy-icon@2x.png') },
                { title: '虾米音乐', icon: require('@/assets/luckybag/xmyy-icon@2x.png') },
                { title: '喜马拉雅', icon: require('@/assets/luckybag/xmly-icon@2x.png') },
                { title: '酷我音乐', icon: require('@/assets/luckybag/kwyy-icon@2x.png') },
                { title: 'QQ', icon: require('@/assets/luckybag/QQ@2x.png') },
                { title: '猫眼', icon: require('@/assets/luckybag/my-icon@2x.png') },
                { title: '作业帮', icon: require('@/assets/luckybag/zyb-icon@2x.png') },
                { title: '咪咕', icon: require('@/assets/luckybag/mg-icon@2x.png') },
                { title: '知乎', icon: require('@/assets/luckybag/zf-icon@2x.png') },
            ],
            titleBar: {
                fullScreen: 2,
                visible: 1,
                leftView: [
                    {
                        action: 'back',
                        color: '#000000',
                        icon: 'ppdwebui://resource/drawable/nav_back',
                        callback: this.goBacktoHome,
                    },
                ],
                titleView: {
                    text: '饿了么红包',
                    color: '#000000',
                },
                rightView: [],
            },
        };
    },
    created() {
        window.PPDWebUI.ListenerService.resumeListener(async () => {
            if (this.goluckBag) {
                this.luckybagpageinfo();
                this.goluckBag = false;
            }
        });
        if (window.PPDWebUI.os.inApp) {
            window.PPDWebUI.CommonService.setNavigation(this.titleBar);
            appBridge.closePullToRefresh();
        }
        this.luckybagpageinfo();
    },
    methods: {
        async luckybagpageinfo() {
            const { Result, Content } = await this.$http.getluckybagpageinfo({});
            if (Result === 200) {
                console.log('content', Content);
                this.totalScore = Content.score;
                this.awardList = Content.awardList[0];
                this.isOldCustomer = Content.isOldCustomer;
                this.showDescrip =
                    this.awardList.awardStatus === 0 || this.awardList.awardStatus === 2;
                if (this.awardList.awardStatus === 10) {
                    this.butn_title = '立即领取';
                } else if (this.awardList.awardStatus === 0 || this.awardList.awardStatus === 2) {
                    this.butn_title = this.isOldCustomer ? '去升级' : '去激活';
                }
                // let level = localStorage.getItem('currLevel');
                let status = this.awardList.awardStatus;
                this.POINT('h5_element_imp', {
                    page: 'super-生活福袋',
                    tgt_event_id: 'h5_ACT_imp',
                    tgt_name: `h5_ACT_生活福袋`,
                    param1: this.totalScore,
                    param3: this.butn_title,
                    param4:
                        status === 0 ? '查看权益详情' : status === 2 ? '点击查看已领取礼券' : '',
                });
            }
        },
        doSomeTask() {
            localStorage.setItem('updata', 'true');
            this.goClose();
        },
        giveupTask() {
            this.showUpdataDialog = false;
        },
        butnClick() {
            if (!this.isOldCustomer) {
                this.butnClickPoint(99, 0);
                this.showDialog = true;
                this.POINT('h5_ACT_button', {
                    page: 'super-激活引导弹窗',
                    tgt_event_id: 'h5_ACT_button',
                    tgt_name: `h5_ACT_激活引导弹窗`,
                    param1: this.totalScore,
                    param2: '生活福袋',
                });
            } else {
                if (this.showDescrip) {
                    this.butnClickPoint(99, 0);
                    // localStorage.setItem('updata', 'true');
                    // this.$router.replace({
                    //     path: '/',
                    // });
                    // this.goClose();
                    this.showUpdataDialog = true;
                } else {
                    this.getluckybagurl(0);
                }
            }
        },
        giveupBtn() {
            this.showDialog = false;
            this.POINT('h5_clk', {
                page: 'super-激活引导弹窗',
                tgt_event_id: 'h5_ACT_button',
                tgt_name: `h5_ACT_激活引导弹窗`,
                param1: this.totalScore,
                param2: '生活福袋',
                param3: '再看看',
            });
        },
        continueBtn() {
            this.POINT('h5_clk', {
                page: 'super-激活引导弹窗',
                tgt_event_id: 'h5_ACT_button',
                tgt_name: `h5_ACT_激活引导弹窗`,
                param1: this.totalScore,
                param2: '生活福袋',
                param3: '去首页',
            });
            this.goHome();
        },
        checkRights() {
            if (this.showDescrip) {
                this.getluckybagurl(1);
            } else {
                this.butnClickPoint(99, 1);
                this.openLink(this.$couponsLink);
            }
        },
        async getluckybagurl(pageType) {
            this.goluckBag = true;
            const { Result, Content, ResultMessage } = await this.$http.getluckybagurl({});
            this.butnClickPoint(Result, pageType);
            if (Result === 200 && Content.url) {
                this.openLink(Content.url);
            } else if (Result === -1) {
                this.$toast({ message: ResultMessage, duration: 2000 });
            } else if (Result === 40719) {
                this.showOverdueDialog = true;
                this.POINT('h5_element_imp', {
                    tgt_event_id: 'h5_ACT_shfd_yuqibox',
                    tgt_name: 'h5-ACT-生活福袋-逾期提示弹窗',
                    page: 'super-生活福袋',
                    param: this.totalScore,
                });
            }
        },
        giveupToRepay() {
            this.showOverdueDialog = false;
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_shfd_yuqibox',
                tgt_name: 'h5-ACT-生活福袋-逾期提示弹窗',
                page: 'super-生活福袋',
                param: this.totalScore,
                param1: '再看看',
            });
        },
        doSomeRepay() {
            this.showOverdueDialog = false;
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_shfd_yuqibox',
                tgt_name: 'h5-ACT-生活福袋-逾期提示弹窗',
                page: 'super-生活福袋',
                param: this.totalScore,
                param1: '去还款',
            });
            this.openLink('ppdloanapp://repayment/index');
        },
        butnClickPoint(Result, pageType) {
            let status = this.awardList.awardStatus;
            this.POINT('h5_clk', {
                page: pageType === 0 ? 'super-生活福袋' : 'super-生活福袋详情',
                tgt_event_id: 'h5_ACT_button',
                tgt_name: pageType === 0 ? 'h5_ACT_生活福袋' : 'h5_ACT_生活福袋详情',
                param1: this.totalScore,
                param2: pageType === 0 ? '点击按钮' : '查看权益详情',
                param3: this.butn_title,
                param4: status === 0 ? '查看权益详情' : status === 2 ? '点击查看已领取礼券' : '',
                param5: Result === 200 ? '成功' : Result === 99 ? '' : '系统异常',
            });
        },
        goBacktoHome() {
            // this.$router.push('/');
            this.goClose();
        },
    },
};
</script>

<style lang="less" scoped>
.page {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    .top-banner {
        width: 100%;
        height: 136px;
        background-image: url('../../../../assets/luckybag/top-banner@2x.png');
        background-size: 100% 100%;
    }
    .title {
        color: #292738;
        font-size: 16px;
        text-align: center;
        font-family: fzlt_bold;
        display: flex;
        justify-content: space-between;
        margin: 32px 100px 0;
        .page-line {
            background-color: #e3ba8a;
            width: 18px;
            height: 2px;
            margin-top: 6px;
        }
    }
    .description {
        color: #999999;
        font-size: 13px;
        font-family: fzlt;
        margin-top: 12px;
        text-align: center;
    }
    .content-title {
        color: #3a465a;
        font-size: 14px;
        margin-top: 32px;
        text-align: center;
        font-family: fzlt_bold;
    }
    .content {
        margin: 16px 18px 0;
        height: 188px;
        background-color: #f7f7f7;
        border-radius: 4px;
        overflow: auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        .bag {
            width: 70px;
            height: 70px;
            margin: 15px 0 5px;
            .bag-icon {
                width: 44px;
                height: 44px;
                margin: 13px;
                background-size: 100% 100%;
            }
            .bag-title {
                margin-top: 5px;
                text-align: center;
                color: #999999;
                font-size: 12px;
            }
        }
    }
    .updata {
        font-size: 14px;
        color: #3a465a;
        font-family: fzlt;
        text-align: center;
        margin-top: 20px;
    }
    .check {
        color: #cf8f44;
        font-size: 14px;
        text-align: center;
        margin-top: 20px;
    }
    .butn {
        margin: 40px 81px 0;
        height: 40px;
        background: linear-gradient(90deg, rgba(63, 69, 97, 1) 0%, rgba(96, 105, 136, 1) 100%);
        border-radius: 21px;
        text-align: center;
        line-height: 40px;
        color: #ece0cf;
        font-size: 16px;
        font-family: fzlt_bold;
    }
    .alert-div {
        margin-top: 12px;
        color: #a4a7b3;
        font-size: 12px;
        text-align: center;
        font-family: fzlt_bold;
    }
}
</style>